<template>
  <div id="kt_header" class="shadow-sm kt-header kt-grid__item kt-header--fixed">
    <div class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
      <div id="kt_header_menu" class="kt-header-menu kt-header-menu-mobile kt-header-menu--layout-default">
        <ul class="kt-menu__nav">
          <li class="kt-menu__item" :class="[currentPage.includes('home') ? 'kt-menu__item--active' : '']">
            <router-link :to="{ name: 'home' }" class="kt-menu__link">
              <span class="d-flex justify-content-center align-items-center">
                <i class="fa fa-home" aria-hidden="true"></i>
              </span>
              <span class="ml-2 kt-menu__link-text">Dashboard</span>
            </router-link>
          </li>

          <li class="kt-menu__item" :class="[currentPage.includes('order') ? 'kt-menu__item--active' : '']">
            <router-link :to="{ name: 'order' }" class="kt-menu__link">
              <span class="d-flex justify-content-center align-items-center">
                <i class="fa fa-shopping-basket" aria-hidden="true"></i>
              </span>
              <span class="ml-2 kt-menu__link-text">Orders</span>
            </router-link>
          </li>

          <li class="kt-menu__item" :class="[currentPage.includes('contact-us') ? 'kt-menu__item--active' : '']">
            <router-link :to="{ name: 'contact-us' }" class="kt-menu__link">
              <span class="d-flex justify-content-center align-items-center">
                <i class="fa fa-address-book" aria-hidden="true"></i>
              </span>
              <span class="ml-2 kt-menu__link-text">Contact Us</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <div v-if="check" class="kt-header__topbar">
      <div class="kt-header__topbar-item kt-header__topbar-item--user">
        <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px">
          <div class="kt-header__topbar-user">
            <span class="kt-header__topbar-welcome kt-hidden-mobile">Hi,</span>
            <span class="kt-header__topbar-username kt-hidden-mobile">{{ user.first_name }}</span>
            <span class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">{{ user.first_name[0] }}</span>
          </div>
        </div>

        <div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          <div class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x" style="background-image: url(/assets/media/user-bg.jpg)">
            <div class="kt-user-card__avatar">
              <span class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">{{ user.first_name[0] }}</span>
            </div>
            <div class="kt-user-card__name">
              {{ user.first_name }} {{ user.last_name }}
            </div>
          </div>

          <div class="kt-notification">
            <a href="#" class="kt-notification__item">
              <div class="kt-notification__item-icon">
                <i class="flaticon2-calendar-3 kt-font-success"></i>
              </div>
              <router-link :to="{ name: 'edit-profile' }" class="kt-notification__item-details">
                <div class="kt-notification__item-title kt-font-bold">My Profile</div>
                <div class="kt-notification__item-time">Account settings and more</div>
              </router-link>
            </a>
            <div class="kt-notification__custom kt-space-between">
              <a href="#" class="btn btn-label btn-label-brand btn-sm btn-bold" @click.prevent="signout">Sign Out</a>
              See you soon! 👋
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Header',
  computed: {
    ...mapGetters({
      check: 'auth/check',
      user: 'auth/user'
    }),
    currentPage() {
      return this.$route.name;
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout'
    }),
    signout() {
      this.logout().then(() => {
        this.$router.replace({
          name: 'login'
        });
      });
    }
  }
};
</script>
